export const ICT_INTERNAL_TENANTS = {
  cenprecast: {
    tid: "e4dbaa67-c457-4734-a2a7-9ff9d3f3e0e8",
    i24hTenant: "cenprecast",
  },
};
